import { colors, defaultShadow, fontSizes, whiteOpacity } from '_/config/theme';
import { useCustomization } from '_/hooks/CustomizationContext';
import { BlurView } from 'expo-blur';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  StyleSheet,
  View,
  Dimensions,
  TouchableOpacity,
  ScrollView,
  Animated,
  Platform,
} from 'react-native';

import Text from '../Text';

interface GDPRModalProps {
  onAccept: () => void;
  onReject: () => void;
  isVisible: boolean;
}

const GDPRModal: React.FC<GDPRModalProps> = ({ onAccept, onReject, isVisible }) => {
  const { t } = useTranslation();

  const { gdpr } = useCustomization();

  if (!isVisible) {
    return null;
  }

  return (
    <Animated.View style={styles.container}>
      <BlurView intensity={80} style={styles.innerContainer}>
        <Animated.View style={styles.content}>
          <View style={styles.header}>
            <Text fontType="bold" center size={fontSizes.xl} color={colors.black}>
              {t('homeScreen.gdpr.title', { defaultValue: 'Termo de Coleta de Dados' })}
            </Text>
          </View>
          <ScrollView>
            <View style={styles.gdprView}>
              <Text color={colors.black} size={fontSizes.lg}>
                {gdpr?.gdprText || ''}
              </Text>
            </View>
          </ScrollView>
          <View style={styles.buttons}>
            <TouchableOpacity style={styles.button} onPress={onReject}>
              <Text color={colors.danger} size={fontSizes.xl2} fontType="bold">
                {t('Reject', { defaultValue: 'Rejeitar' })}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.button} onPress={onAccept}>
              <Text color={colors.dark3} size={fontSizes.xl2} fontType="bold">
                {t('Accept', { defaultValue: 'Aceitar' })}
              </Text>
            </TouchableOpacity>
          </View>
        </Animated.View>
      </BlurView>
    </Animated.View>
  );
};

export default GDPRModal;

const { width, height } = Dimensions.get('window');

const styles = StyleSheet.create({
  container: {
    zIndex: 999,
    backgroundColor: Platform.OS === 'android' ? whiteOpacity : colors.transparent,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    elevation: 5,
  },
  innerContainer: {
    padding: 40,
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  header: {
    textAlign: 'center',
    paddingVertical: 18,
  },
  content: {
    backgroundColor: colors.white,
    width: width > height ? height : '80%',
    maxHeight: '80%',
    borderRadius: 12,
    borderColor: colors.light3,
    borderWidth: 1,
    ...defaultShadow,
  },
  gdprView: {
    alignItems: 'center',
    paddingHorizontal: 24,
    marginBottom: 12,
  },
  buttons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 8,
    borderTopColor: colors.light3,
    borderTopWidth: 2,
  },
  button: {
    flex: 1,
    alignItems: 'center',
    paddingHorizontal: 18,
    paddingVertical: 16,
  },
});
